import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-nedir-nasil-yapilir/page.tsx");
